/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {useContext, useState} from 'react';
import NotificationsModule from "./notificationsModule";
import {SubscriptionModuleProps} from "../../subscriptionSettingsController";
import {AppContext} from "../../../../misc/appContext";
import {SubscriptionModuleName} from "../../../../../util/enums";
import Subscription from "../../../../../models/subscriptionModel";
import {ResponseData, showDialog, showSnackbar} from '@dvrd/dvr-controls';
import {createErrorMessage} from "../../../../../util/utils";
import Account from "../../../../../models/accountModel";
import User from "../../../../../models/userModel";

export default function NotificationsModuleController(props: SubscriptionModuleProps) {
    const context = useContext(AppContext);
    const {user} = context.userContext;
    const {account} = context.accountContext;
    const [loading, setLoading] = useState(false);

    function onToggleModule(activate: boolean) {
        return function() {
            const subscription = user?.subscription;
            if (!subscription || !account) return;
            setLoading(true);
            if (activate) onActivate(subscription, account, user);
            else onConfirmCancel(subscription, account, user);
        }
    }

    function onActivate(subscription: Subscription, account: Account, user: User) {
        subscription.addModule({accountID: account.id, moduleName: SubscriptionModuleName.NOTIFICATIONS},
            (subscription: Subscription, success: boolean, data: ResponseData) => {
                setLoading(false);
                if (success) {
                    showSnackbar('De Notificaties & AI Analyze module is geactiveerd');
                    user.subscription = subscription;
                    context.onChangeContext({user});
                } else
                    showDialog(
                        createErrorMessage(data.message ?? 'Het activeren van de Notificaties & AI Analyze module ' +
                            'is niet gelukt.'),
                        'Activeren mislukt');
            });
    }

    function onConfirmCancel(subscription: Subscription, account: Account, user: User) {
        showDialog('Weet je zeker dat je deze feature uit wilt schakelen? Je ontvangt dan geen meldingen ' +
            'van nieuwe reviews op jouw producten meer en kunt geen gebruik meer maken van BolmateAI.',
            'Feature uitschakelen',
            [{label: 'Ja, feature uitschakelen', primary: false, onClick: onCancel(subscription, account, user)},
                'Nee']);
    }

    function onCancel(subscription: Subscription, account: Account, user: User) {
        return function() {
            subscription.cancelModule({accountID: account.id, moduleName: SubscriptionModuleName.NOTIFICATIONS},
                (subscription: Subscription, success: boolean, data: ResponseData) => {
                    setLoading(false);
                    if (success) {
                        showSnackbar('De Notificaties & AI Analyze module is gedeactiveerd');
                        user.subscription = subscription;
                        context.onChangeContext({user});
                    } else
                        showDialog(
                            createErrorMessage(
                                data.message ?? 'Het deactiveren van de Notificaties & AI Analyze module is niet gelukt.'),
                            'Deactiveren mislukt');
                });
        }
    }

    return (
        <NotificationsModule onToggleModule={onToggleModule} loading={loading || props.loading}
                             usageLastMonth={props.usageLastMonth}/>
    );
}